import ApiService from '@/api';
import { GetOrderHistoryListRequestModel, GetOrderHistoryListResponseModel } from '../models';
import { ResponseModel } from 'tir-pm-file-upload-manager';

export class AdapterService {
  private readonly api = new ApiService();

  /**Получить список истории очередности */
  getOrderHistoryList(
    req: GetOrderHistoryListRequestModel,
  ): Promise<ResponseModel<GetOrderHistoryListResponseModel>> {
    return new Promise<ResponseModel<GetOrderHistoryListResponseModel>>(async (resolve) => {
      let result = new ResponseModel<GetOrderHistoryListResponseModel>();
      await this.api.Main.TaskOrderGetService.getOrderHistoryListAsync(req)
        .then((resp) => {
          result.Value = resp;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getOrderHistoryList', e);
        });
    });
  }
}
